<template>
  <svg id="icon-clients" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-120.5-12.5h554v512h-554z"/>
      <g transform="translate(12.82 10.595)">
        <circle stroke="currentColor" cx="2.89" cy="2.89" r="2.89"/>
        <path d="M1.972 2.202a.917.917 0 1 1 1.835 0 .917.917 0 0 1-1.835 0zm2.202 2.18c0 .11-2.569.11-2.569 0v-.395c0-.547 1.1-.99 1.285-.99.195 0 1.284.443 1.284.99v.396z" fill="currentColor" fill-rule="nonzero"/>
      </g>
      <g transform="translate(1.6 10.506)">
        <circle stroke="currentColor" cx="2.89" cy="2.89" r="2.89"/>
        <path d="M1.972 2.202a.917.917 0 1 1 1.835 0 .917.917 0 0 1-1.835 0zm2.202 2.18c0 .11-2.569.11-2.569 0v-.395c0-.547 1.1-.99 1.285-.99.195 0 1.284.443 1.284.99v.396z" fill="currentColor" fill-rule="nonzero"/>
      </g>
      <g transform="translate(7.012 3.7)">
        <circle stroke="currentColor" cx="2.89" cy="2.89" r="2.89"/>
        <path d="M1.972 2.202a.917.917 0 1 1 1.835 0 .917.917 0 0 1-1.835 0zm2.202 2.18c0 .11-2.569.11-2.569 0v-.395c0-.547 1.1-.99 1.285-.99.195 0 1.284.443 1.284.99v.396z" fill="currentColor" fill-rule="nonzero"/>
      </g>
      <path d="M11.923 8.653l2.063 2.576M7.92 9.05L6.7 11.228" stroke="currentColor" stroke-linecap="square"/>
    </g>
  </svg>
</template>
